import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa6";

const PasswordInput = ({ lableName, onChange, value, name }) => {
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={lableName}>{lableName}</label>
      <div className="flex gap-1 items-center px-4 rounded-xl border h-[50px] overflow-hidden">
        <input
          className="2xl:h-16 w-full focus:outline-none"
          type={showPassword ? "text" : "password"}
          name={name}
          placeholder="Enter Password"
          value={value}
          onChange={onChange}
        />
        <div className="cursor-pointer" onClick={toggleShowPassword}>
          {showPassword ? <FaEye /> : <FaEyeSlash />}
        </div>
      </div>
    </div>
  );
};

export default PasswordInput;
